import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Admin {
    id: string;
    email: string;
    role: 'super_admin' | 'province_admin' | 'municipal_admin' | 'staff';
    fullName: string;
    provinceId?: string;
    municipalityId?: string;
}

interface AuthState {
    token: string | null;
    admin: Admin | null;
    isAuthenticated: boolean;
    login: (token: string, admin: Admin) => void;
    logout: () => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set): AuthState => ({
            token: null,
            admin: null,
            isAuthenticated: false,
            login: (token: string, admin: Admin) => set({ token, admin, isAuthenticated: true }),
            logout: () => set({ token: null, admin: null, isAuthenticated: false })
        }),
        { name: 'muni-admin-auth' }
    )
);
